import React, { useState, useEffect } from 'react';

const ExitIntentPopup = ({ onGetStarted }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const shown = sessionStorage.getItem('exitIntentShown');
    if (shown) {
      setHasShown(true);
      return;
    }

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !hasShown && !showPopup) {
        setShowPopup(true);
        setHasShown(true);
        sessionStorage.setItem('exitIntentShown', 'true');
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown, showPopup]);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleGetStarted = () => {
    setShowPopup(false);
    if (onGetStarted) {
      onGetStarted();
    }
  };

  if (!showPopup) return null;

  return (
    <div 
      className="exit-intent-overlay"
      onClick={handleClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(93, 58, 59, 0.8)',
        backdropFilter: 'blur(5px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div 
        className="exit-intent-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '500px',
          width: '100%',
          position: 'relative',
          animation: 'slideIn 0.3s ease-out',
          background: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(20px)',
          borderRadius: '24px',
          border: '1px solid rgba(30, 58, 95, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(139, 90, 91, 0.3)'
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            color: '#5d3a3b',
            cursor: 'pointer',
            padding: '0',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(30, 58, 95, 0.1)'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          ×
        </button>

        <div className="text-center" style={{ padding: '2rem' }}>
          <div className="mb-3">
            <i className="bi bi-heart-fill" style={{ fontSize: '3rem', color: '#1e3a5f' }}></i>
          </div>
          
          <h2 className="mb-3" style={{ fontSize: '1.75rem', fontWeight: '700', color: '#5d3a3b', fontFamily: "'Cormorant Garamond', serif" }}>
            Wait! Perfect Vows Await
          </h2>
          
          <p className="mb-3" style={{ fontSize: '1.1rem', color: '#5d3a3b', lineHeight: '1.6' }}>
            <strong>Don't let writer's block ruin your big moment</strong>
          </p>
          
          <p style={{ fontSize: '1rem', color: '#8b5a5b', lineHeight: '1.6', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
            Your wedding vows should be perfect. VowAuthor helps you express your love with beautiful, 
            heartfelt words — all for just <strong style={{ color: '#1e3a5f' }}>$9.99</strong>.
          </p>

          <div className="alert mb-4" style={{ 
            background: 'rgba(232, 164, 174, 0.15)', 
            border: '1px solid rgba(30, 58, 95, 0.3)',
            color: '#5d3a3b',
            borderRadius: '12px',
            padding: '1rem',
            textAlign: 'left'
          }}>
            <strong>What You Get:</strong>
            <ul className="mb-0 mt-2" style={{ paddingLeft: '1.5rem' }}>
              <li>5 personalized vow generations</li>
              <li>Perfect for both partners to use</li>
              <li>Elegant, print-ready PDFs</li>
              <li>Use anytime — no expiration</li>
            </ul>
          </div>

          <div className="d-flex flex-column gap-3 justify-content-center align-items-center">
            <button
              className="btn btn-primary btn-lg pulsate-btn w-100"
              onClick={handleGetStarted}
              style={{ maxWidth: '300px' }}
            >
              <i className="bi bi-heart-fill me-2"></i>
              Create My Vows - $9.99
            </button>
            
            <div style={{ 
              width: '100%', 
              maxWidth: '300px', 
              textAlign: 'center', 
              color: '#8b5a5b',
              fontSize: '0.9rem'
            }}>
              — or —
            </div>
            
            <a
              href="/free-vow-prompts"
              className="btn btn-outline-secondary btn-lg w-100"
              onClick={handleClose}
              style={{ 
                maxWidth: '300px', 
                color: '#1e3a5f', 
                borderColor: '#1e3a5f',
                background: 'rgba(30, 58, 95, 0.05)'
              }}
            >
              <i className="bi bi-download me-2"></i>
              Get Free Vow Prompts
            </a>
            
            <button
              className="btn btn-link"
              onClick={handleClose}
              style={{ color: '#8b5a5b', fontSize: '0.9rem', textDecoration: 'none' }}
            >
              No thanks, I'll figure it out myself
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ExitIntentPopup;
